exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".tab-navigation li a.active-tab,.tab-navigation li a.selected,.tab-navigation li a:active{z-index:1!important}.reject-confirmation-modal header{background-color:#fff!important}.reject-confirmation-modal .reject-modal-body{background-color:#f1f1f1!important;color:#000!important}.reject-confirmation-modal .reject-modal-body .modal-popup{color:#aaa;display:-ms-flexbox;display:flex;-ms-flex-flow:row wrap;flex-flow:row wrap;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-size:1.6rem;margin-left:1%;padding-bottom:5px;width:60%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader!./src/product/transfers/components/modal/modal-body.scss
// module id = 5165
// module chunks = 0